<template>
  <div id="app">
    <header-my class="header-pc"></header-my>
    <header-wap class="header-wap"></header-wap>
    <router-view/>
  </div>
</template>

<script>
import headerWap from './components/headerWap'
import headerMy from './components/header'
export default {
  name: 'App',
  components: {
    headerMy,
    headerWap
  }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.header-wap{
  display: none;
}
@media (max-width: 1024px)
{
  #app{
    .header-pc{
      display: none;
    }
    .header-wap{
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue